import { BaseRequestsService } from '@/services/base-requests-service';

class WalletRequests extends BaseRequestsService {

  getWallets() {
    return this.http.get('v1/wallets');
  }

}

const walletRequests = new WalletRequests();
export { walletRequests as WalletRequests };
